import React from "react";
import { Box } from "@chakra-ui/react";

export function CarIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize={12} viewBox="0 0 256 256">
      <Box as="path" fill="none" d="M0 0h256v256H0z" />
      <Box
        as="line"
        x1="16"
        y1="120"
        x2="240"
        y2="120"
        fill="new.yellow.150"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <Box
        as="path"
        d="M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184"
        fill="new.yellow.150"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <Box
        as="path"
        d="M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184"
        fill="new.yellow.150"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <Box
        as="line"
        x1="64"
        y1="152"
        x2="80"
        y2="152"
        fill="new.yellow.150"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <Box
        as="line"
        x1="176"
        y1="152"
        x2="192"
        y2="152"
        fill="new.yellow.150"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <Box
        as="path"
        d="M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z"
        fill="none"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </Box>
  );
}
